import HorizontalRule from '@tiptap/extension-horizontal-rule';

import { type Editor } from '@tiptap/core';

export const isTableGripSelected = (node: HTMLElement) => {
  let container = node;

  while (container && !['TD', 'TH'].includes(container.tagName)) {
    const parent = container.parentElement;
    if (!parent) break;
    container = parent;
  }

  const gripColumn = container?.querySelector?.('button.grip-column.selected');
  const gripRow = container?.querySelector?.('button.grip-row.selected');

  return Boolean(gripColumn || gripRow);
};

export const isCustomNodeSelected = (editor: Editor, node: HTMLElement) => {
  const customNodes = [HorizontalRule.name];

  return customNodes.some((type) => editor.isActive(type)) || isTableGripSelected(node);
};
